import { useEconomicCalendarSectionContent } from './useEconomicCalendarSectionContent';
import { parseEconomicCalendarMacroHighlightsContent } from '../utils/economicCalendarContent';

export const useEconomicCalendarMacroHighlightsContent = () =>
  useEconomicCalendarSectionContent(parseEconomicCalendarMacroHighlightsContent);
